import {FC} from "react";
import {OptionType} from "../../../../common/types";
import styled from "@emotion/styled";

export interface ETASelectionRendererProps {
  title: string;
  arrayOfValues: OptionType[];
}

export const ETASelectionRenderer: FC<ETASelectionRendererProps> = ({title, arrayOfValues}) => {
  return arrayOfValues.length === 0 ? null : (
    <ETASelectionContainer>
      <ETASelectionTitle>{title}</ETASelectionTitle>
      <ETASelectionValue>{arrayOfValues.map((i) => i.value).join(", ")}</ETASelectionValue>
    </ETASelectionContainer>
  );
};

const ETASelectionContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;
`;

const ETASelectionTitle = styled.div`
  white-space: nowrap;
  font-weight: 500;
  font-size: 14px;
`;

const ETASelectionValue = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #6b7280;
`;
